import React from "react";

type Tone = "primary" | "green" | "amber" | "violet";

const toneStyles: Record<Tone, string> = {
  primary: "bg-primary/10 text-primary",
  green: "bg-emerald-50 text-emerald-600",
  amber: "bg-amber-50 text-amber-600",
  violet: "bg-violet-50 text-violet-600",
};

interface KpiCardProps {
  icon: React.ReactNode;
  label: string;
  value: number;
  hint?: React.ReactNode;
  tone?: Tone;
}

const KpiCard: React.FC<KpiCardProps> = ({
  icon,
  label,
  value,
  hint,
  tone = "primary",
}) => (
  <div className="flex items-center gap-4 rounded-2xl border border-slate-200/80 bg-white p-5 shadow-[0_1px_2px_rgba(16,24,40,0.04)] transition-shadow hover:shadow-md">
    <div
      className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${toneStyles[tone]}`}
    >
      {icon}
    </div>
    <div className="min-w-0">
      <p className="text-[13px] font-medium text-slate-500">{label}</p>
      <p className="text-[28px] font-semibold leading-tight text-slate-900">
        {(value ?? 0).toLocaleString()}
      </p>
      {hint && <p className="mt-0.5 truncate text-xs text-slate-400">{hint}</p>}
    </div>
  </div>
);

export default KpiCard;
